import React from 'react'
import CartMobile from '@page-components/Order/CartV3/CartMobile'
import useLayout from '@page-components/Order/useLayout'

export default function Cart() {
  const layout = useLayout()
  if (layout === 'mobile') return <CartMobile />
}
